export function thousandsWhiteSpacing(input: number | string | undefined | null): string {
  if (input === null || input === undefined) {
    return ''
  }

  const value = input.toString()

  if (input === 0) {
    return value
  }

  let result = ''
  let counter = 0

  for (let i = value.length - 1; i >= 0; i--) {
    if (counter === 3) {
      result += ' '
      counter = 0
    }
    result += value[i]
    counter++
  }

  return result.split('').reverse().join('')
}
